import Vue from 'vue'
// 全局导入就行
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Element)
